import useLocalStorage from "./useLocalStorage";
import { BackgroundTaskSubscriptionEvents, BackgroundTaskSubscriptionChannels } from "~/client/resources/backgroundTaskSubscriptionResource";

export interface AutoSubscribeSettings {
    enabled: boolean;
    defaultEvents: BackgroundTaskSubscriptionEvents;
    defaultChannel: BackgroundTaskSubscriptionChannels;
}

interface AutoSubscribeSettingsResult {
    settings: AutoSubscribeSettings;
    setSettings: (value: AutoSubscribeSettings) => void;
}

const defaultSettings: AutoSubscribeSettings = {
    enabled: false,
    defaultEvents: BackgroundTaskSubscriptionEvents.BackgroundTaskFailed,
    defaultChannel: BackgroundTaskSubscriptionChannels.Slack
};

function setCookie(name: string, value: string, days: number = 365) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/;SameSite=Lax`;
}

export function useAutoSubscribeSettings(): AutoSubscribeSettingsResult {
    const [settings, setLocalStorageSettings] = useLocalStorage<AutoSubscribeSettings>("autoSubscribeSettings", defaultSettings);

    const setSettings = (value: AutoSubscribeSettings) => {
        // Update local storage for UI persistence
        setLocalStorageSettings(value);
        
        // Update cookie for backend consumption
        setCookie("autoSubscribeSettings", JSON.stringify(value));
    };

    return { settings, setSettings };
}

export function getAutoSubscribeSettingsSync(): AutoSubscribeSettings | null {
    try {
        const stored = localStorage.getItem("autoSubscribeSettings");
        return stored ? JSON.parse(stored) : null;
    } catch {
        return null;
    }
}
